import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提成明细表")
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提成明细表")
const _hoisted_6 = { key: 1 }

import { ref, Ref, reactive, onActivated } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import {statusFunc, typeFunc} from '@/views/typeMapping/Commission.ts'
import router from '@/router/index'
import { formatNumber } from '@/utils/index'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props: any) {

const props = __props as {}

const {
  'POST/commission/distribute': fetchList,
} = Api


const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

const searchObj = reactive({
  userId: '', monthRange: [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')],
})
const searchHandle = () => {
  fetchData({
    userId: searchObj.userId,
    month: {
      from: searchObj.monthRange && searchObj.monthRange[0],
      to: searchObj.monthRange && searchObj.monthRange[1],
    }
  })

}
searchHandle()


const switchDetails = (row: any) => {
  router.push({path: '/comission', query: {ids: row.orderNos.join(',')}})
}


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "点此搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _unref(searchObj),
              inline: "",
              disabled: _unref(MI_identify),
              class: "searchBg"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "姓名:",
                  prop: "userId"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(searchObj).userId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).userId) = $event)),
                      placeholder: "请选择用户姓名",
                      clearable: "",
                      filterable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.getters.sysUsers, (user) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: `${user.alias} (${user.realName})`,
                            value: user.userId,
                            key: user.userId
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "时间范围:",
                  prop: "monthRange"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      onClear: _cache[1] || (_cache[1] = ($event: any) => (_unref(searchObj).monthRange = [])),
                      modelValue: _unref(searchObj).monthRange,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).monthRange) = $event)),
                      type: "monthrange",
                      "value-format": "YYYY-MM-DD",
                      "start-placeholder": "开始月份",
                      "range-separator": "至",
                      "end-placeholder": "结束月份"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) - 40 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "expand" }, {
          default: _withCtx(({row}) => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_el_table, {
                data: row.detailData,
                class: "ml-30",
                style: {"width":"700px"},
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "提成类型",
                    prop: "type",
                    formatter: (row) => _unref(typeFunc)()[row.type]
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: "来源",
                    prop: "source"
                  }, {
                    default: _withCtx(({row}) => [
                      (row.source === '提成明细表')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            type: "primary",
                            onClick: ($event: any) => (switchDetails(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(row.source), 1))
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_table_column, {
                    label: "备注",
                    prop: "note",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "本月金额",
                    prop: "amount",
                    align: "right",
                    formatter: _unref(formatNumber)
                  }, null, 8, ["formatter"])
                ]),
                _: 2
              }, 1032, ["data"]),
              _createVNode(_component_el_table, {
                data: row.detailData,
                class: "ml-30",
                style: {"width":"700px"},
                border: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "提成类型",
                    prop: "type",
                    formatter: (row) => _unref(typeFunc)()[row.type]
                  }, null, 8, ["formatter"]),
                  _createVNode(_component_el_table_column, {
                    label: "来源",
                    prop: "source"
                  }, {
                    default: _withCtx(({row}) => [
                      (row.source === '提成明细表')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            type: "primary",
                            onClick: ($event: any) => (switchDetails(row))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(row.source), 1))
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_table_column, {
                    label: "备注",
                    prop: "note",
                    "show-overflow-tooltip": ""
                  }),
                  _createVNode(_component_el_table_column, {
                    label: "CO2计算结果（USD）",
                    prop: "usdAmount",
                    align: "right",
                    formatter: _unref(formatNumber)
                  }, null, 8, ["formatter"])
                ]),
                _: 2
              }, 1032, ["data"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "提成人",
          prop: "owner"
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(`${row.realName} (${row.owner})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "计算提成月份",
          prop: "month"
        }),
        _createVNode(_component_el_table_column, {
          label: "总提成金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "CO2计算结果（USD）",
          prop: "usdAmount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "",
          prop: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          formatter: (row) => _unref(statusFunc)()[row.status]
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[5] || (_cache[5] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      disabled: _unref(MI_identify),
      "page-sizes": [10, 30, 50, 100, 300],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "disabled", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})